import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'pdf-acroform-default-theme',
  template: '',
  styleUrls: ['./pdf-acroform-default-colors.css'],
  encapsulation: ViewEncapsulation.None,
})
export class PdfAcroformDefaultThemeComponent {}
